import { Outlet, createFileRoute } from '@tanstack/react-router';

/**
 * Layout for the System section.
 *
 * Deliberately a pass-through: every screen under /system owns its whole
 * viewport (the page never scrolls — see DESIGN.md), so there is no shared
 * chrome to hang here. Its only job is to give /system/registers,
 * /system/staff, /system/sync and /system a common breadcrumb root.
 */
export const Route = createFileRoute('/_app/system')({
  staticData: { crumb: 'System' },
  component: () => <Outlet />,
});
